import ko from 'knockout';
import templateMarkup from 'raw-loader!./kpicell-widget.html';
import _ from 'lodash';

function KpiCellWidget(params) {
    var self = this;

    self.observableOptions = params.observableOptions;
    self.observableData = params.observableData;
    self.panelTemplate = params.panelTemplate;
    self.widgetSignals = params.widgetSignals;
    self.dataProvider = params.dataProvider;
    self.subscriptions = [];

    self.loadMode = true;

    var options = params.observableOptions();

    self.kpiList = ko.observableArray([]);
    self.selectedKpi = ko.observable();

    self.value = ko.observable('0');

    self.changeindicator = ko.observable('--');
    self.kpicellchangeindicatorstyle = ko.observable('kpicellchangeindicatorstyle text-gray');

    self.changevalue = ko.observable('0');
    self.kpicellchangevaluestyle = ko.observable('kpicellchangevaluestyle text-gray');

    self.kpicelllabelstyle = 'kpicelllabelstyle';

    self.loadOptions = function () {

        var options = params.observableOptions();

        if (options.selectedKPIColumnNames && (options.selectedKPIColumnNames.length > 0)) {
            var kpi = options.selectedKPIColumnNames[0];

            if (_.isString(kpi)) kpi = _.toLower(kpi);

            self.selectedKpi(kpi);
        }

        self.loadMode = false;
    };

    self.saveOptions = function () {
        var options = params.observableOptions();

        options.selectedKPIColumnNames = [self.selectedKpi()];

        params.observableOptions(options);
    };

    self.subscriptions.push(params.observableData.subscribe(function () {
        self.DataUpdated();
    }));

    self.subscriptions.push(params.observableOptions.subscribe(function () {
        self.OptionsUpdated();
    }));

    self.loadData = function () {
        if (!params.viewLevelOptions()) return;

        var obsparams = params.observableParamsList[0]();
        var paramsTemp = params.viewLevelOptions();

        paramsTemp.aggregatefact = getAggregeFact(self.kpiList(), self.selectedKpi());
        paramsTemp.WhereCondition = ko.toJSON([]);

        paramsTemp.groupby = '';
        paramsTemp.filter = '1=1';
        paramsTemp.dataset = '';
        paramsTemp.timegrain = '';
        paramsTemp.tag = '';
        paramsTemp.sortColumn = '';

        obsparams.paramsJson = ko.toJSON(paramsTemp);
        obsparams.panelId = options.id;

        if (self.widgetSignals) {
            self.widgetSignals.dataRequested.dispatch();
        }

        params.observableParamsList[0](obsparams);
    };

    if (params.viewLevelOptions) {
        self.subscriptions.push(params.viewLevelOptions.subscribe(function (newval) {
            if (self.loadMode) return;

            self.loadData();
        }));
    }

    self.subscriptions.push(self.selectedKpi.subscribe(function (newKpiKey) {
        if (self.loadMode) return;

        self.saveOptions();
    }));


    self.RefreshData();
}

KpiCellWidget.prototype.RefreshData = function () {
    var self = this;
    var data = self.observableData();

    if (_.isEmpty(data)) {
        return;
    }

    if (_.isEmpty(self.kpiList()) && !_.isEmpty(data.metadata)) {
        var kpiList =  _.filter(data.metadata.Table, ['dashboardKPIFlag', 1]);

        self.kpiList(kpiList);
        self.loadOptions();

        return self.loadData();
    }

    if (data.Table && data.Table.length) {
        self.value(data.Table[0].aggregateFact ? parseFloat(data.Table[0].aggregateFact).toFixed(0) : 0);
    }

    if (data.Table1 && data.Table1.length) {
        var oldvalue = data.Table1[0].aggregateFact ? data.Table1[0].aggregateFact : 0;

        self.changevalue(parseFloat((self.value() - oldvalue) * 100 / (oldvalue ? oldvalue : 1)).toFixed(0));

        self.changeindicator(self.changevalue() < 0 ? "<i class='flaticon-sort37'></i>" : self.changevalue() > 0 ? "<i class='flaticon-sort33'></i>" : "--");

        var color = self.changevalue() < 0 ? 'text-red' : self.changevalue() > 0 ? 'text-green' : 'text-gray';

        self.kpicellchangeindicatorstyle('kpicellchangeindicatorstyle ' + color);
        self.kpicellchangevaluestyle('kpicellchangevaluestyle ' + color);
        self.changevalue(self.changevalue() + '%');
    }
};

KpiCellWidget.prototype.DataUpdated = function () {
    var self = this;

    self.RefreshData();

    // Signal dataLoaded when the data request has been fulfilled and the data is updated.
    if (self.widgetSignals && self.widgetSignals.dataLoaded) {
        self.widgetSignals.dataLoaded.dispatch();
    }
};

KpiCellWidget.prototype.OptionsUpdated = function () {
    var self = this;

    self.loadMode = true;
    self.loadOptions();

    self.loadData();
};

KpiCellWidget.prototype.dispose = function () {
    var self = this;

    self.subscriptions.forEach(function (sub) {
        sub.dispose();
    });
};

function getAggregeFact(kpiList, selectedKpi) {
    var selectedMetric = _.find(kpiList, ['columnKey', selectedKpi]);
    var aggregateFunction = _.get(selectedMetric, 'aggregateFunction', 'sum');

    return aggregateFunction + '(' + selectedKpi + ')';
}

export default {
    viewModel: KpiCellWidget,
    template: templateMarkup
};
